<template>
  <div
    class="tw-p-2 tw-border tw-border-primary tw-border-solid tw-rounded-xl md:tw-grid md:tw-grid-cols-2 tw-gap-3"
  >
    <button
      v-if="file.id"
      type="button"
      @click="confirmDelete"
      class="tw-border tw-border-solid tw-border-red-500 tw-rounded-lg tw-text-red-500 tw-px-2 tw-col-span-2"
    >
      <i class="fas fa-trash"></i>
    </button>

    <ValidationProvider
      v-slot="{ errors }"
      :name="inputfile.name"
      :rules="file.id ? '' : inputfile.rules"
      v-for="inputfile in data.child.inputs"
      :key="inputfile.key + inputfile.value"
    >
      <div class="input_wrapper">
        <div class="tw-flex tw-items-center tw-justify-between tw-mb-2">
          <label :for="inputfile.name">{{ inputfile.label }}</label>
        </div>
        <div
          class="tw-flex tw-items-center tw-justify-between tw-mb-2 tw-gap-2"
        >
          <v-file-input
            :disabled="btnLoading"
            :loading="btnLoading"
            @change="uploadImage($event, inputfile)"
            :name="inputfile.name"
            label=""
            v-model="file[inputfile.value]"
            :id="inputfile.name"
            ref="uploadInput"
          ></v-file-input>

          <button
            v-if="inputfile.modelValue.preview"
            type="button"
            @click="openModal(inputfile.modelValue.preview)"
            class="tw-border tw-border-solid tw-rounded-lg tw-text-text tw-px-2"
          >
            <i class="fas fa-eye"></i>
          </button>

          <media-modal
            v-if="openPreview"
            :preview="itemToPreview"
            type="image"
            @close="openPreview = false"
          />
        </div>
      </div>
      <span v-if="errors[0]" class="error--text d-inline-block">
        {{ errors[0] }}
      </span>
    </ValidationProvider>
    <div v-for="(data, index) in data.child.alts" :key="index">
      <component
        :is="data.inputType"
        :name="data.name"
        v-model="data.modelValue"
        :placeholder="data.placeholder"
        :label="data.label"
        :rules="data.rules"
        :type="data.type"
        :data="data"
        :modalName="data.modalName"
        :api-url="data.apiUrl"
        @imageDeleted="imageDeleted(index)"
      ></component>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    name: {
      required: true,
    },
    label: {
      required: false,
    },
    rules: {
      required: true,
    },
    data: {
      required: false,
    },
    type: {
      required: false,
      default: "text",
    },

    placeholder: {
      required: false,
    },
    modalName: {
      required: false,
    },
  },
  data() {
    return {
      file: {
        id: "",
        ar: null,
        en: null,
      },
      itemToPreview: null,
      openPreview: false,
      btnLoading: false,
    };
  },
  methods: {
    uploadImage(event, inputfile) {
      console.log(inputfile);

      if (event) {
        this.btnLoading = true;
        const data = new FormData();
        data.append("file", event);
        data.append("attachment_type", "image");
        data.append("model", inputfile.modalName);

        this.axios({
          method: "POST",
          url: `${process.env.VUE_APP_BASE_URL_GENERAL}/api/general/attachments`,
          data: data,
        })
          .then((res) => {
            inputfile.modelValue = {
              image: res.data.data,
              preview: URL.createObjectURL(event),
              src: event,
            };
            this.$emit("input", inputfile);
            this.btnLoading = false;
          })
          .catch((err) => {
            event = null;

            this.$iziToast.error({
              title: this.$t("validation.error"),
              message: err.response.data.message,
            });

            this.btnLoading = false;
          });
      }
    },
    async deleteImage() {
      let id = this.file.id;

      await this.axios({
        method: "DELETE",
        url: `${process.env.VUE_APP_BASE_URL_GENERAL}/api/general/attachments/${this.file.id}`,
      })
        .then(() => {
          this.$emit("imageDeleted", id);
          this.$swal({
            title: "تم الحذف بنجاح",
            icon: "success",
            confirmButtonColor: "#3085d6",
            confirmButtonText: "نعم",
          });
          this.file.id = "";
        })
        .catch((err) => {
          this.$swal({
            title: err.response.data.message,
            icon: "error",
            confirmButtonColor: "#d33",
            confirmButtonText: "اغلاق",
          });
        });
    },
    confirmDelete() {
      this.$swal({
        title: "هل أنت متأكد؟",
        text: "سيتم حذف الصوره بالنص البديل لن يكون بإمكانك الرجوع في العملية!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        cancelButtonText: "لا",
        confirmButtonText: "احذف",
      }).then((result) => {
        if (result.isConfirmed) {
          this.deleteImage();
        }
      });
      // End:: Sweet Alert  Modal
    },
    updateValue() {
      this.$emit("input", this.file);
    },
    openModal(item) {
      this.itemToPreview = item;
      this.openPreview = true;
    },
  },
  mounted() {
    if (this.data.id) {
      this.file.id = this.data.id;
    }
  },
};
</script>
